import { render, staticRenderFns } from "./servicerLogin.vue?vue&type=template&id=3282b8e1&scoped=true&"
import script from "./servicerLogin.vue?vue&type=script&lang=js&"
export * from "./servicerLogin.vue?vue&type=script&lang=js&"
import style0 from "./servicerLogin.vue?vue&type=style&index=0&id=3282b8e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3282b8e1",
  null
  
)

export default component.exports